export class Message {

    id?: string;
    title: string = '';
    text: string = '';
    targetUserGroup: string = '';
    categoryId?: string;
    seen?: number;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    userId?: string;
    createdById?: string;
    createdBy?: { id: string; firstName: string; lastName: string };
    // Sent messages come back grouped per send
    batchId?: string;
    recipientType?: 'all' | 'category' | 'user';
    recipientLabel?: string;
    recipientsCount?: number;
    seenCount?: number;

    constructor(raw?: Message) {
        if (raw) {
            this.title = raw.title;
            this.text = raw.text;
            this.targetUserGroup = raw.targetUserGroup;
            this.userId = raw.userId;
            this.seen = raw.seen;
            this.createdById = raw.createdById;
            this.categoryId = raw.categoryId;
        }
    }

}
